import { useState, useEffect, useCallback } from 'react';
import { BREAKPOINTS } from '../utils/responsive';

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: typeof window !== 'undefined' ? window.innerWidth : undefined,
        height: typeof window !== 'undefined' ? window.innerHeight : undefined,
    });

    const updateWindowSize = useCallback(() => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }, []);

    useEffect(() => {
        window.addEventListener('resize', updateWindowSize);
        updateWindowSize();
        return () => window.removeEventListener('resize', updateWindowSize);
    }, [updateWindowSize]);

    return {
        width: windowSize.width,
        height: windowSize.height,
        effectiveWidth: windowSize.width,
        effectiveHeight: windowSize.height,
        isMobile: windowSize.width && windowSize.width < BREAKPOINTS.md,
        isTablet: windowSize.width && windowSize.width >= BREAKPOINTS.md && windowSize.width < BREAKPOINTS.lg,
        isDesktop: windowSize.width && windowSize.width >= BREAKPOINTS.lg,
    };
};

export const useIntersectionObserver = (options = {}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [ref, setRef] = useState(null);

    useEffect(() => {
        if (!ref) return;

        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        }, {
            threshold: 0.1,
            ...options
        });

        observer.observe(ref);

        return () => {
            if (ref) {
                observer.unobserve(ref);
            }
        };
    }, [ref, options]);

    return [setRef, isVisible];
};
